<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		components: {}
	}
</script>

<style>
	#app {
		background: #f5f7f9;
		width: 100%;
		height: 100%;
	}
</style>